import React from 'react';
import {
  getSubCategoryId,
  Step_1_Enter,
  Step_2_Enter,
  Step_2_Verify,
  Step_3_Enter,
} from '../../utils/DictionaryManagementUtils';
import { LocStr } from '../../utils/Utils';
import SimulatorsViewerArrangement from '../SimulatorsComponents/FullPagesComponents/SimulatorsViewerArrangement';
import ManualRecipientFP from '../SimulatorsComponents/FullPagesComponents/Services/Recipient/ManualRecipientFP';

const DefaultSimManuelRecipient = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
  manualName,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const manual_recipient = globJSON.configurations.services[subCategoryId].recipient.manual_recipients[manualName];
  const verifyRecipient = manual_recipient.enable_recipient_validation;
  const addContactName = manual_recipient.save_to_list && manual_recipient.add_contact_name;

  return (
    <SimulatorsViewerArrangement>
      <ManualRecipientFP
        globJSON={globJSON}
        selectedScreen={selectedScreen}
        simPlatform={simPlatform}
        headlineText={manual_recipient.enter_details}
        manualName={manualName}
        TopTitle={LocStr(verifyRecipient || addContactName ? Step_1_Enter : ' ', language)}
        slideshowRefs={slideshowRefs}
      />
      {(verifyRecipient || addContactName) && (
        <ManualRecipientFP
          globJSON={globJSON}
          selectedScreen={selectedScreen}
          simPlatform={simPlatform}
          manualName={manualName}
          TopTitle={LocStr(verifyRecipient ? Step_2_Verify : Step_2_Enter, language)}
          headlineText={manual_recipient.enter_details}
          isFormFilled
          slideshowRefs={slideshowRefs}
          toAddContactName={addContactName && !verifyRecipient}
        />
      )}
      {(verifyRecipient && addContactName) && (
        <ManualRecipientFP
          globJSON={globJSON}
          selectedScreen={selectedScreen}
          simPlatform={simPlatform}
          manualName={manualName}
          TopTitle={LocStr(Step_3_Enter, language)}
          headlineText={manual_recipient.enter_details}
          isFormFilled
          toAddContactName={addContactName}
          slideshowRefs={slideshowRefs}
        />
      )}

    </SimulatorsViewerArrangement>
  );
};

export default DefaultSimManuelRecipient;
